export const formStyles = () => ({
    formMain: {
        padding: 30,
    },
});
